// store/index.ts
import { createStore } from 'redux';
import rootReducer from './reducers';

// ✅ 全局唯一 store 实例
export const store = createStore(rootReducer);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
